var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-navbar',{staticClass:"vgtc-navbar justify-content-center align-items-stretch",attrs:{"type":"light","sticky":true}},[_c('div',{staticClass:"vgtc-navbar__content d-flex flex-column flex-grow-1 justify-content-between pb-2 pt-2"},[_c('Header')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }